import * as constants from './constants';
import abbr from '../../../../config/abbr';
import { message } from 'antd';
import { apiLogin } from '../../../../config/index';

export const toggleUserNameErr = (value, text) => ({
	type: constants.TOGGLE_USERNAME_ERR,
	value, text
})

export const togglePassErr = (value, text) => ({
	type: constants.TOGGLE_PASS_ERR,
	value, text
})

export const handleUserNameChange = (value) => ({
	type: constants.HANDLE_USERNAME_CHANGE,
	value
})

export const handlePasswordChange = (value) => ({
	type: constants.HANDLE_PASSWORD_CHANGE,
	value
})

export const loginf = (name, pass) => {
	let formData = {
		username: name,
		password: pass,
		auto: '1'
	}
	return (dispatch) => {
		dispatch(manuBtnClickF(true));
		apiLogin(formData).then(response => {
			if(response.code === abbr.okId){
				let timestamp1 = new Date().getTime() + 1000*60*60*3;
				localStorage.setItem('lsisLogin', true);
				localStorage.setItem('userObj', JSON.stringify(response.data));
				localStorage.setItem('userPassTime', timestamp1);
				window.location.href = abbr.ipIndex;
			}else{
				message.error(response.msg);
			}
			dispatch(resetForm());
			dispatch(manuBtnClickF(false));
		}).catch(error => {
		  console.log(error)
		})
	}
}

export const resetForm = () => ({
	type: constants.RESET_FORM,
})

const manuBtnClickF = (value) => ({
	type: constants.MANU_BTN_CLICK,
	value
})